var readMore = document.getElementsByClassName('show-hidden-text');
var hiddenText = document.getElementsByClassName('hidden_text');
var slideDown = element => element.style.height = `${element.scrollHeight}px`;

for (let i = 0; i < readMore.length; i++) {
    readMore[i].addEventListener('click', function() {
        hiddenText[i].style.display = 'block';
        slideDown(hiddenText[i]);
        console.log(i);
        readMore[i].classList.add('show-hidden-text--hide-me');
    })
}
